export const MARKET_NEWS = [
  { id: "dollar", category: "Currencies", time: "09:40", title: "Dollar steadies as traders look ahead to the next policy update." },
  { id: "europe", category: "Macroeconomics", time: "09:15", title: "European markets weigh a mixed picture for growth and inflation." },
  { id: "gold", category: "Commodities", time: "08:50", title: "Gold holds a narrow range as attention turns to incoming economic data." },
  { id: "liquidity", category: "Market structure", time: "08:20", title: "Trading desks watch liquidity conditions ahead of the session overlap." },
];

const EVENT_TEMPLATES = [
  { currency: "EUR", name: "Consumer price index", impact: "High", previous: "2.4%", forecast: "2.3%", actual: "2.3%", time: "09:00" },
  { currency: "USD", name: "Retail sales", impact: "High", previous: "0.2%", forecast: "0.3%", actual: null, time: "12:30" },
  { currency: "GBP", name: "Consumer confidence", impact: "Medium", previous: "−18", forecast: "−16", actual: null, time: "14:00" },
  { currency: "JPY", name: "Industrial production", impact: "Medium", previous: "0.5%", forecast: "0.3%", actual: null, time: "04:30" },
  { currency: "USD", name: "Initial jobless claims", impact: "High", previous: "218K", forecast: "221K", actual: null, time: "12:30" },
  { currency: "AUD", name: "Business confidence", impact: "Low", previous: "4", forecast: "5", actual: null, time: "01:30" },
  { currency: "EUR", name: "Manufacturing outlook", impact: "Medium", previous: "47.8", forecast: "48.1", actual: null, time: "08:00" },
];

const dateKey = (date) => date.toISOString().slice(0, 10);
const addDays = (date, days) => new Date(date.getTime() + days * 86400000);

// Dates stay useful in the frontend prototype. Every event/value remains synthetic.
export const getCalendar = (now = new Date()) => {
  const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const tomorrow = addDays(today, 1);
  const monday = addDays(today, -((today.getUTCDay() + 6) % 7));
  const sunday = addDays(monday, 6);
  const weekday = (today.getUTCDay() + 6) % 7;
  const events = Array.from({ length: 8 }, (_, index) => ({
    ...EVENT_TEMPLATES[index % EVENT_TEMPLATES.length], id: `week-${index}`, date: dateKey(addDays(monday, index)),
  }));
  events.push(
    { ...EVENT_TEMPLATES[(weekday + 1) % 7], id: "today-second", date: dateKey(today), time: "13:30" },
    { ...EVENT_TEMPLATES[(weekday + 2) % 7], id: "today-third", date: dateKey(today), time: "15:00" },
    { ...EVENT_TEMPLATES[(weekday + 3) % 7], id: "tomorrow-second", date: dateKey(tomorrow), time: "14:30" },
  );
  return {
    today: dateKey(today), tomorrow: dateKey(tomorrow), weekStart: dateKey(monday), weekEnd: dateKey(sunday),
    events: events.sort((a, b) => `${a.date}${a.time}`.localeCompare(`${b.date}${b.time}`)),
  };
};